import { storage_keys } from '@/constant/configs';
import Cookies from 'js-cookie';
import { CustomerProfile } from '@/lib/types/customer/Profile';
import { useRouter } from 'next/navigation';
import { logOut } from '@/clients/customer/auth';
import toast from 'react-hot-toast';
import {
  removeCustomerAuthCreds,
  removeCustomerImpersonateIDs,
} from '@/lib/utils/functions';
import {
  setShowFailedOrderPopup,
  removeFailedOrderInfo,
} from '@/lib/utils/storage';

interface AuthResponse {
  data: {
    token: string;
    refresh_token: string;
    user: CustomerProfile;
    token_expires_at: string;
  };
}

type SetUserFunction = (user: CustomerProfile) => void;
type removeUserFunc = () => void;

export default function useCustomerAuth() {
  const router = useRouter();

  const handleCustomerLogin = (
    res: AuthResponse,
    setUser: SetUserFunction,
    redirectTo = '/'
  ) => {
    Cookies.set(storage_keys.customer_token, res.data.token, {
      expires: new Date(res.data.token_expires_at),
    });
    localStorage.setItem(storage_keys.customer_token, res.data.token);
    localStorage.setItem(
      storage_keys.customer_refresh_token,
      res.data.refresh_token
    );
    setUser(res.data.user);
    window.location.href = redirectTo; // TODO: redirect to correct url & investigate later with native next.js approach
  };

  const handleCustomerLogout = (
    removeUser: removeUserFunc,
    redirect = true
  ) => {
    logOut()
      .then(() => {
        removeCustomerAuth(removeUser, redirect);
      })
      .catch((err) => {
        toast.error(err?.response?.message);
      });
  };

  const removeCustomerAuth = (
    removeUser: removeUserFunc,
    redirect = true
  ): void => {
    removeCustomerAuthCreds();
    setShowFailedOrderPopup(false);
    removeFailedOrderInfo();
    removeUser();

    removeCustomerImpersonateIDs();

    if (redirect) {
      window.location.href = '/';
    }
  };

  const checkAuthAndRedirect = async (authToken?: string) => {
    if (authToken) {
      router.push('/');
    }
  };

  return {
    handleCustomerLogin,
    checkAuthAndRedirect,
    handleCustomerLogout,
    removeCustomerAuth,
  };
}
